import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import IntermediateUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import intermediateIcon from "../../../../../assets/design-revamp-company/category-icons/intermediate-use-icon.svg";
const IntermediateUseContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_INTERMEDIATE_TITLE")}
          subDescription={t("COMP_INTERMEDIATE_DESC")}
          isNormal={true}
          number={"17.1.3"}
          icon={intermediateIcon}
        />
      </div>
      {showTable && <IntermediateUseSoldTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default IntermediateUseContents;
